import React from 'react';
import { useAppConstantsContext } from '@/context/AppConstants';
import { Modal, Text, Button, styled } from '@/theme/index';

const StyledContainer = styled('div')`
  text-align: center;
  width: 100%;
`;

export interface SourceModalProps {
  open: boolean;
  closeModal: () => void;
}

export function SourceModal({ open, closeModal }: SourceModalProps) {
  const {
    data: { brandName },
  } = useAppConstantsContext();
  return (
    <Modal open={open} onClose={closeModal}>
      <StyledContainer>
        <Text variant="h1" color="primary" fontWeight={500}>
          Digitized records may include
        </Text>
      </StyledContainer>
      <Text variant="h4"> Sex Offenders</Text>
      <Text fontSize={14}>
        {brandName} runs a search in a nationwide database that aggregates
        public information from state, territorial and local registries
      </Text>
      <br />
      <Text variant="h4">Court Records</Text>
      <Text fontSize={14}>
        Many counties and states offer digitized access to criminal and traffic
        records. Note that even if a court has digitized coverage, not all
        records, may be digitally accessible.
      </Text>
      <br />
      <Text variant="h4">Department of Corrections</Text>
      <Text fontSize={14}>
        {brandName} also searches many local Department of Corrections that may
        pick up additional relevant data such as arrest records, outstanding
        warrants, and convictions.
      </Text>
      <br />
      <StyledContainer>
        <Button onClick={closeModal} variant="outlined" color="success">
          Go back to report
        </Button>
      </StyledContainer>
    </Modal>
  );
}
